export function getFormatToFbToolsUtil(item): string {
  return `${item.name} ${item.surname}|${item.ua}|${item.cookie}|${item.password}|`
}
